import React from "react";
import "./ForecastTable.css";
import {FileUtils} from "../../../utils/fileUtils";
import AppConfig from "../../../config/AppConfig";


export class ForecastTable extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            forecastHtml: null,
            extendedForecastHtml: null,
        }
    }

    componentDidMount() {
        FileUtils.getForecastToday(this.props.cst)
            .then(text => this.setState({ forecastHtml: text }));
        FileUtils.getForecastExtended(this.props.cst)
            .then(text => this.setState({ extendedForecastHtml: text }));
    }



    render(){
        return(
            <table className={"forecast-table"} cellPadding={0} cellSpacing={0}>

                <thead className="forecast-table-head">
                    <tr>
                        <th className={"forecast-inner-column-inner-column"}>
                            {this.props.i18n.Forecast_Table_Discussion}
                        </th>
                        <th className={"forecast-inner-column-inner-column"}>
                            {this.props.i18n.Forecast_Table_Extended}
                        </th>
                    </tr>
                </thead>

                <tbody>
                <tr className={"forecast-text-row"}>
                    <th
                        className={"forecast-table-text"}
                        dangerouslySetInnerHTML={{
                            __html: (!this.state.forecastHtml || /<html/i.test(this.state.forecastHtml))
                                ? this.props.i18n.Forecast_Discussion_Unavailable
                                : this.state.forecastHtml
                        }}
                    />
                    <th
                        className={"forecast-table-text"}
                        dangerouslySetInnerHTML={{
                            __html: (!this.state.extendedForecastHtml || /<html/i.test(this.state.extendedForecastHtml))
                                ? this.props.i18n.Forecast_Table_Extended_Unavailable
                                : this.state.extendedForecastHtml
                        }}
                    />
                </tr>
                </tbody>

            </table>
        )
    }
}
